var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Editor, Range, Element, Point } from "slate";
export var withPlugins = function (editor) {
    var isInline = editor.isInline, isVoid = editor.isVoid, deleteForward = editor.deleteForward, deleteBackward = editor.deleteBackward, insertBreak = editor.insertBreak, insertNode = editor.insertNode;
    editor.isInline = function (element) {
        return ["link", "button"].includes(element.type) || isInline(element);
    };
    editor.isVoid = function (element) {
        return ["image", "embed", "video", "horizontal", "unsplash"].includes(element.type)
            ? true
            : isVoid(element);
    };
    editor.deleteBackward = function (unit) {
        var selection = editor.selection;
        if (selection && Range.isCollapsed(selection)) {
            var _a = __read(Editor.nodes(editor, {
                match: function (n) {
                    return !Editor.isEditor(n) &&
                        Element.isElement(n) &&
                        n.type === "table-cell";
                },
            }), 1), cell = _a[0];
            if (cell) {
                var _b = __read(cell, 2), cellPath = _b[1];
                var start = Editor.start(editor, cellPath);
                if (Point.equals(selection.anchor, start)) {
                    return;
                }
            }
        }
        deleteBackward(unit);
    };
    editor.deleteForward = function (unit) {
        var selection = editor.selection;
        if (selection && Range.isCollapsed(selection)) {
            var _a = __read(Editor.nodes(editor, {
                match: function (n) {
                    return !Editor.isEditor(n) &&
                        Element.isElement(n) &&
                        n.type === "table-cell";
                },
            }), 1), cell = _a[0];
            if (cell) {
                var _b = __read(cell, 2), cellPath = _b[1];
                var end = Editor.end(editor, cellPath);
                if (Point.equals(selection.anchor, end)) {
                    return;
                }
            }
        }
        deleteForward(unit);
    };
    editor.insertBreak = function () {
        var selection = editor.selection;
        if (selection) {
            var _a = __read(Editor.nodes(editor, {
                match: function (n) {
                    return (!Editor.isEditor(n) && Element.isElement(n) && n.type === "table");
                },
            }), 1), table = _a[0];
            var _b = __read(Editor.nodes(editor, {
                match: function (n) {
                    return (!Editor.isEditor(n) &&
                        Element.isElement(n) &&
                        ["heading-one", "heading-two"].includes(n.type));
                },
            }), 1), subTitle = _b[0];
            if (table) {
                return;
            }
            if (subTitle) {
                var newNode = {
                    type: subTitle[0].type,
                    children: [{ text: "" }],
                    id: Math.random().toString(),
                };
                insertNode(newNode);
                return;
            }
        }
        insertBreak();
    };
    return editor;
};
